'use client';

import { Button } from '@shared/ui/components';

import styles from './ErrorPage.module.scss';

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Something went wrong</div>

      <Button size="s" variant="filled" onClick={() => reset()}>
        Try refreshing the page
      </Button>
    </div>
  );
}
